export enum BannerMessageLevel {
  error = 'error',
  critical = 'critical'
}
